import { render } from "./advspreadinfo.vue?vue&type=template&id=a78f01e4&scoped=true"
import script from "./advspreadinfo.vue?vue&type=script&lang=js"
export * from "./advspreadinfo.vue?vue&type=script&lang=js"

import "./advspreadinfo.vue?vue&type=style&index=0&id=a78f01e4&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a78f01e4"]])

export default __exports__